import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TextareaAutosize from 'react-textarea-autosize'
import { ReactComponent as DropdownTransparent } from '../../../assets/svg/DropdownTransparent.svg'
import { ReactComponent as SearchBlue } from '../../../assets/svg/SearchBlue.svg'
import Loading from '../../Loading'
import { notify } from '../../../utils/util'

const AssignActionPanel = ({ loadedTeachers, superiorTeachers, processingAction, onSubmit }) => {
    const { t } = useTranslation()
    const [showDropdown, setShowDropdown] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [teachers, setTeachers] = useState(loadedTeachers)
    const [selectedTeacher, setSelectedTeacher] = useState({})
    const [message, setMessage] = useState('')

    const selectedTeacherName = selectedTeacher.first_name
        ? `${selectedTeacher.first_name} ${selectedTeacher.last_name}`
        : null

    useEffect(() => {
        if (searchTerm.length > 0) {
            setTeachers(loadedTeachers.filter((teacher) => `${teacher?.first_name} ${teacher?.last_name}`.toLowerCase().includes(searchTerm.toLowerCase())))
        } else {
            setTeachers(loadedTeachers)
        }
    }, [searchTerm, loadedTeachers])

    const handleSubmit = () => {
        if (selectedTeacher.first_name === undefined) {
            notify(t('Select teacher'), 'warning')
            return
        }
        if (message === '') {
            notify(t('youMustFillData'), 'warning')
            return
        }
        onSubmit(selectedTeacher, message)
    }

    const selectTeacher = (teacher) => {
        setSelectedTeacher(teacher)
        setShowDropdown(false)
        setSearchTerm('')
    }

    return (
        <div className="assign-action-container overflow-visible">
            <div className="w-full flex flex-row items-center justify-between">
                <p className="text-[18px] leading-[22px] font-semibold text-deepPurple">{t('assignedTo')}</p>
                <p className="text-[14px] leading-5 font-medium text-deepPurple">{selectedTeacherName ?? ''}</p>
            </div>
            <div
                className="flex flex-col max-h-[calc(78vh-180px)] overflow-auto no-scroll mb-[10px] z-50 relative w-full mt-4 rounded-b-3xl"
                onMouseLeave={(e) => e.preventDefault()}
            >
                <div
                    className={`w-full min-h-[55px] ${
                        showDropdown ? 'bg-deepPurple border-deepPurple' : 'bg-lightBG border-lightBG'
                    } border hover:border-deepPurple rounded-[54px] flex flex-row items-center justify-center z-[3] cursor-pointer overflow-visible`}
                    onClick={(e) => {
                        e.preventDefault()
                        if (searchTerm !== '') setSearchTerm('')
                        setShowDropdown(!showDropdown)
                    }}
                    id="select-teacher-dropdown"
                >
                    <p
                        className={`text-[18px] leading-[22px] font-semibold ${
                            showDropdown ? 'text-white' : selectedTeacherName ? 'text-darkenPurple' : 'text-deepPurple'
                        }`}
                    >
                        {selectedTeacherName ?? t('selectTeacher')}
                    </p>
                    <div style={{ transform: showDropdown ? 'scaleY(-1)' : 'none', marginLeft: 10 }}>
                        <DropdownTransparent style={{ color: showDropdown ? 'white' : '#5E639B' }} />
                    </div>
                </div>
                {showDropdown && (
                    <div className="-mt-[55px] flex flex-col items-center w-full bg-lightBG rounded-[28px] z-[2]">
                        <div className="w-full mt-[55px]">
                            <div className="feedback-teachers-list" style={{ paddingRight: 13, paddingLeft: 12, width: '100%' }}>
                                <div className="feedback-management-search-container">
                                    <input
                                        type="text"
                                        id="search-input"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        autoComplete="off"
                                        placeholder={t('search')}
                                    />
                                    <SearchBlue />
                                </div>
                                {superiorTeachers.headOfClass !== undefined && (
                                    <div
                                        onClick={() => selectTeacher(superiorTeachers.headOfClass)}
                                        className="w-full min-h-[50px] bg-white rounded-[5px] flex flex-row items-center justify-between mb-2 px-5 cursor-pointer border border-highlightColor hover:bg-highlightColor"
                                    >
                                        <p className="text-[16px] leading-5 font-bold text-darkenPurple">
                                            {superiorTeachers?.headOfClass?.first_name} {superiorTeachers?.headOfClass?.last_name}
                                        </p>
                                        <p className="text-[14px] leading-5 font-medium text-deepPurple">{t('classroomTeacher')}</p>
                                    </div>
                                )}
                                {superiorTeachers.headOfYear !== undefined && (
                                    <div
                                        onClick={() => selectTeacher(superiorTeachers.headOfYear)}
                                        className="w-full min-h-[50px] bg-white rounded-[5px] flex flex-row items-center justify-between mb-2 px-5 cursor-pointer border border-highlightColor hover:bg-highlightColor"
                                    >
                                        <p className="text-[16px] leading-5 font-bold text-darkenPurple">
                                            {superiorTeachers?.headOfYear?.first_name} {superiorTeachers?.headOfYear?.last_name}
                                        </p>
                                        <p className="text-[14px] leading-5 font-medium text-deepPurple">{t('headOfYear')}</p>
                                    </div>
                                )}
                                {(superiorTeachers.headOfYear !== undefined || superiorTeachers.headOfClass !== undefined) && (
                                    <p className="text-[14px] leading-5 font-medium text-deepPurple my-[15px] text-center">{t('otherTeachers')}</p>
                                )}
                                {teachers?.map((teacher, index) => (
                                    <div
                                        onClick={() => selectTeacher(teacher)}
                                        key={index}
                                        className="w-full min-h-[50px] bg-white rounded-[5px] flex flex-row items-center justify-between mb-2 px-5 cursor-pointer"
                                    >
                                        <p className="text-[16px] leading-5 font-bold text-darkenPurple">
                                            {teacher?.first_name} {teacher?.last_name}
                                        </p>
                                        <p className="text-[14px] leading-5 font-medium text-deepPurple">{teacher?.role_coverage?.target_text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {!showDropdown && (
                <div className="feedback-assigned-multiline" style={{ marginTop: 20 }}>
                    <div className="feedback-textarea">
                        <TextareaAutosize
                            placeholder={t('typeAnAction')}
                            minRows={4}
                            value={message}
                            id="action-message-textarea"
                            style={{ resize: 'none' }}
                            autoFocus
                            onChange={(e) => {
                                e.preventDefault()
                                setMessage(e.target.value)
                            }}
                        />
                    </div>
                    <div className="textarea-button" onClick={handleSubmit} id="text-area-button">
                        <p>{processingAction ? <Loading /> : t('submit')}</p>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AssignActionPanel
